import React from "react";
import OrderTimer from "./OrderTimer";
import ActiveOrderProfit from "./ActiveOrderProfit";
import { ClosedOrderStatus, OrderHeader, OrderRow } from "../entities/order";
import { formatDate, formatTime } from "../shared/utils";

import "./Order.css";

export interface IOrder {
  id: string;
  status: "open" | "closed" | "cancelled";
  type: "buy" | "sell";
  amount: number;
  symbol: string;
  openPrice: number;
  timestamp: number;
  closePrice?: number | undefined;
  closeTimestamp?: number | undefined;
  demo_balance: boolean;
  potential_profit_win?: number | undefined;
  potential_profit_loss?: number | undefined;
  profit?: number | undefined;
}

type OrderProps = {
  order: IOrder;
};

const Order: React.FC<OrderProps> = ({ order }) => {
  const isOpen = order.status === "open";
  const isClosed = order.status === "closed";

  return (
    <div key={order.id} className="order">
      <OrderHeader type={order.type} amount={order.amount} />

      <div className="order__details">
        <OrderRow label="Pair" value={order.symbol} />
        <OrderRow label="Entry Price" value={order.openPrice.toFixed(5)} />

        {isOpen && (
          <OrderRow label="Time" value={formatTime(order.timestamp)} />
        )}

        {isClosed && order.closePrice && (
          <OrderRow label="Exit Price" value={order.closePrice.toFixed(5)} />
        )}

        {isClosed && (
          <OrderRow label="Date" value={formatDate(order.timestamp)} />
        )}

        {isClosed && order.closeTimestamp && (
          <OrderRow
            label="Close Time"
            value={formatTime(order.closeTimestamp)}
          />
        )}

        <OrderRow
          label="Account"
          value={
            <span
              className={`account-type ${order.demo_balance ? "demo" : "real"}`}
            >
              {order.demo_balance ? "Demo" : "Real"}
            </span>
          }
        />
      </div>

      {isOpen && (
        <div className="order__status">
          {order.closeTimestamp ? (
            <OrderTimer closeTimestamp={order.closeTimestamp} />
          ) : (
            <span className="status-active">🟢 Active</span>
          )}

          {/* Отображение предварительной прибыли */}
          <ActiveOrderProfit order={order} />
        </div>
      )}

      {isClosed && <ClosedOrderStatus profit={order.profit} />}
    </div>
  );
};

export default Order;
